/**
 * Angular imports.
 */
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { EventMsgService } from '../../dataservices/master-service/event-msg.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';

/**
 * Animation imports.
 */
import { listAnimation, animationIII, animationV, fadeee } from '../../animations/utility.animation';

/**
 * Library imports.
 */
import { ModalDirective } from 'ngx-bootstrap/modal';
/**
 * Constant import.
 */
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT_NAME, REPOST_STATUS, SCREEN_NAME } from '../../constants/app.constants';
/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

/**
 * Posting Component
 */
@Component({
  selector: 'app-posting',
  templateUrl: './posting.component.html',
  styleUrls: ['./posting.component.scss'],
  animations: [animationIII, animationV, listAnimation, fadeee]
})
export class PostingComponent implements OnInit, OnDestroy {
  @ViewChild('autoShownModal') autoShownModal: ModalDirective;
  @Output() resetis_open_posting = new EventEmitter();
  @Output() resetFeedPostModal = new EventEmitter();
  @Input() is_open_posting;
  @Input() channel_info;
  @Input() show_feed_post_modal;

  public post_screen = 0;
  public postType = 'post';

  public previousScreen = NUMBERS.ZERO;

  public sourceScreenName = this.funCollectionService.currentScreename;
  /**
   * Repost status.
   */
  public repostStatus = REPOST_STATUS;

  /**
   * Necessary instances.
   */
  constructor(
    public igs: ImageGroupService,
    public ems: EventMsgService,
    public funCollectionService: FunCollectionService,
    public multiLangService: MultiLangService,
    private dss: DataStorageService,
    public mls: NewLanguageService,
    private analyticSdk: Analytics
  ) {
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    if (localStorage.getItem('postDraftData') != null) {
      this.dss.postDraftData = [];
      this.dss.postDraftData = JSON.parse(localStorage.getItem('postDraftData'));
    }
  }

  /**
   * show Post Modal
   */
  showPostModal(): void {
    this.show_feed_post_modal = true;
  }

  /**
   * onHidden
   */
  onHidden(): void {
    this.show_feed_post_modal = false;
    this.post_screen = 0;
    this.dss.edit_draft_index = '';
    this.dss.calling_from_community_object = {};
    this.resetPost();
    this.resetFeedPostModal.emit(0);
  }

  /**
   * reset Post
   */
  resetPost(): void {
    this.post_screen = 0;
    this.dss.resetPostData();
  }

  /**
   * next Post Screen
   */
  nextPostScreen(screen): void {
    if (this.previousScreen == NUMBERS.ZERO) {
      this.sourceScreenName = SCREEN_NAME.FEED_POSTING;
    }
    else if (this.previousScreen == NUMBERS.ONE) {
      this.sourceScreenName = SCREEN_NAME.TAG_PEOPLE;
    }
    else if (this.previousScreen == NUMBERS.TWO) {
      this.sourceScreenName = SCREEN_NAME.POST_TYPE;
    }
    else if (this.previousScreen == NUMBERS.THREE) {
      this.sourceScreenName = SCREEN_NAME.POST_DRAFT_LIST
    }
    else if (this.previousScreen == NUMBERS.FOUR) {
      this.sourceScreenName = SCREEN_NAME.POST_ASSOCIATION
    }
    if (screen == 6) {
      this.onHidden();
    } else if (screen == 6.1) {
      this.show_feed_post_modal = false;
      this.post_screen = 0;
      this.dss.edit_draft_index = '';
      this.resetFeedPostModal.emit(0);
    } else {
      this.post_screen = screen;
    }
    this.previousScreen = screen;
  }

  /**
   * continue edit post
   */
  continueEditPost(): void {
    this.nextPostScreen(0);
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.CONTINUE_EDIT, null);
  }

  /**
   * cancel Close
   */
  cancelClose(): void {
    if (this.dss.posting_data.screen1.feed_kind == 'poll') {
      this.dss.posting_data.screen1.feed_kind = 'poll';
      this.post_screen = 0;
    } else {
      this.dss.posting_data.screen1.feed_kind = 'post';
      this.post_screen = 0;
    }
  }

  /**
   * saveAs Draft
   */
  saveAsDraft(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING,this.dss.posting_data.repostProductType ?? '0',SCREEN_NAME.FEED_POSTING, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.SAVE_TO_DRAFT, null);
      this.dss.nextButtonEnabled = false;
    if (this.dss.edit_draft_index == '') {
      const x = new Date();
      const y = x.getTime();
      this.dss.posting_data.creation_time = parseInt(y.toString(), 10);
      this.dss.posting_data.screen1.media = this.dss.temp_post_media;
      this.dss.postDraftData.unshift(this.dss.posting_data);
      localStorage.setItem('postDraftData', JSON.stringify(this.dss.postDraftData));
    } else {
      this.dss.postDraftData[parseInt(this.dss.edit_draft_index, 10)] = this.dss.posting_data;
      this.dss.edit_draft_index = '';
      localStorage.setItem('postDraftData', JSON.stringify(this.dss.postDraftData));
    }

    if (this.post_screen != 5) {
      this.onHidden(); return;
    }
    if (this.dss.posting_data.screen1.feed_kind == 'poll') {
      this.resetPost();
      this.dss.posting_data.screen1.feed_kind = 'poll';
    } else {
      this.onHidden();
    }
  }

  /**
   * discard Post
   */
  discardPost(): void {
    this.analyticSdk.analyticService.CLICK
    (PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.FEED_POSTING, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.DISCARD_POST, null);
    this.dss.nextButtonEnabled = false;
    this.dss.resetRepostData();
    if (this.dss.edit_draft_index != '') {
      this.dss.postDraftData.splice(parseInt(this.dss.edit_draft_index, 10), 1);
      this.dss.edit_draft_index = '';
      localStorage.setItem('postDraftData', JSON.stringify(this.dss.postDraftData));
    }
    if (this.post_screen != 5) {
      this.onHidden();
      return;
    }
    if (this.dss.posting_data.screen1.feed_kind == 'poll') {
      this.resetPost();
      this.dss.posting_data.screen1.feed_kind = 'poll';
    } else {
      this.onHidden();
    }
  }

  /**
   * On destry on posting component.
   */
  ngOnDestroy(): void {
    this.dss.calling_from_community = NUMBERS.ZERO;
  }
}

